import { colors } from './colors';
import { hexToRgb } from 'helpers/hexToRgb';

export const elevation = <const>{
  md: `0px 20px 25px -5px rgba(${hexToRgb(colors.black, 'string')}, .1), 
    0px 10px 15px -5px rgba(${hexToRgb(colors.black, 'string')}, .04)`,
};
